import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from '../../../../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';

@Component({
  selector: 'app-table-column-time-interval',
  templateUrl: './table-column-time-interval.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TableColumnTimeIntervalComponent extends TableViewAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

}
